<template>
  <div
    ref="headerWrapper"
    :class="{ stickyClass: sticky, normalClass: !sticky }"
    style="height: 100px"
  >
    <div
      ref="header"
      class="header-wrapper"
      :style="{ 'background-color': back, color: font }"
    >
      <div class="d-flex top">
        <div class="flex-1">
          <slot name="left"></slot>
        </div>
        <h2>
          {{ text }}
        </h2>
        <div class="flex-1">
          <slot name="right"></slot>
        </div>
      </div>
      <hr class="line" :style="{ 'border-top': '2px solid ' + font }" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    sticky: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
    back: {
      type: String,
      default: "",
    },
    font: {
      type: String,
      default: "",
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (!this.$refs.headerWrapper.classList.contains("stickyClass")) {
        return;
      }

      const stickyOffsetTop = this.$refs.header.getBoundingClientRect().top;

      if (stickyOffsetTop <= 0) {
        this.$refs.header.classList.add("stuck");
      } else {
        this.$refs.header.classList.remove("stuck");
      }
    },
  },
};
</script>

<style lang="scss">
.stickyClass {
  position: sticky;
  pointer-events: none;
  top: 0;
  z-index: 3;
}

.normalClass {
  position: relative;
  z-index: 3;
}

.header-wrapper {
  color: black;
  padding: 1em;
  height: 100%;
  transition: height 0.3s ease, padding 0.3s ease;

  .line {
    display: block;
    height: 1px;
    border: 0;
    border-top: 2px solid black;
    margin: 1em auto;
    padding: 0;
    margin-top: 1em;
    width: 7em;
  }

  .top {
    padding-top: 10px;
  }

  h2 {
    text-transform: uppercase;
    word-spacing: 5px;
    font-size: 16px;
    line-height: 1.5;
  }

  .flex-1 {
    flex: 1;
  }
}
</style>

<style>
.header-wrapper.stuck {
  height: 50px;
  padding: 0;
  transition: height 0.3s ease, padding 0.3s ease;
}

.stuck .line {
  display: none;
}
</style>
